import React from 'react';
import { StethoscopeIcon, QuoteIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { audiences } from '../data/content';
const thoughts = ['I already have a system. It’s just mostly in my head.', 'I have templates, but they’re scattered everywhere.', 'I keep recreating the same documents.', 'My workflow has evolved, but I’ve never actually documented it.', 'I know my process could be more organized.'];
export function Audience() {
  return <section className="bg-cream px-4 py-16 sm:py-24" data-id="element-21" data-mp="btauud890551">
      <div className="mx-auto max-w-4xl" data-id="element-22" data-mp="plqs0xegx8y1">
        <SectionHeading eyebrow="Who I created this for" title={<>Built for <em className="text-gold-dark" data-id="element-24" data-mp="ljdqymao1z7l">qualified professionals</em></>} data-id="element-23" data-mp="pkfpf0wre78i" />
        <p className="mx-auto mt-5 max-w-2xl text-center text-lg leading-relaxed text-ink/70" data-id="element-25" data-mp="zj58uy4azzqv">
          For professionals working within rhinoplasty and related facial-plastic workflows.
        </p>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-26" data-mp="16d84ddnfwhb6">
          {audiences.map(a => <li key={a.title} className="flex gap-4 rounded-2xl bg-white p-5 ring-1 ring-ink/10" data-id="element-27" data-mp="1bbt4ld2oz0zm">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-ink" data-id="element-28" data-mp="1gbe3xolrxbcv">
                <StethoscopeIcon className="h-5 w-5 text-gold-light" aria-hidden="true" data-id="element-29" data-mp="1kchlcfjgzfg7" />
              </span>
              <div data-id="element-30" data-mp="1pccb2fridyzo">
                <h3 className="text-lg font-extrabold text-ink" data-id="element-31" data-mp="1pasq4buwqzrk">{a.title}</h3>
                <p className="mt-1 text-[16px] leading-snug text-ink/70" data-id="element-32" data-mp="1uadpuohwjc5c">{a.text}</p>
              </div>
            </li>)}
        </ul>

        <h3 className="mt-16 text-center font-serif text-3xl font-black leading-tight text-ink" data-id="element-33" data-mp="1z2fbv24vgh8k">
          You’ll get the most value if you find yourself thinking…
        </h3>
        <ul className="mx-auto mt-8 max-w-2xl space-y-3" data-id="element-34" data-mp="283my2lu45rma">
          {thoughts.map(t => <li key={t} className="flex gap-3 rounded-2xl bg-ink px-5 py-4" data-id="element-35" data-mp="2d2gcqhl4zoo1">
              <QuoteIcon className="mt-1 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-36" data-mp="cynmv4ggjd3u" />
              <p className="font-serif text-xl font-bold italic leading-snug text-white" data-id="element-37" data-mp="8xtyk9z3rwaf">“{t}”</p>
            </li>)}
        </ul>
        <p className="mt-8 text-center text-lg font-semibold text-ink" data-id="element-38" data-mp="mpql7yi05dzf">If any of those sound familiar, that’s exactly why I built this.</p>

        <SectionCta label="That’s me — I want the Playbook" data-id="element-39" data-mp="hwfbnplt2j3t" />
      </div>
    </section>;
}